/**
 * UTM Tracking - Captura parámetros de URL y los guarda en localStorage
 * Se ejecuta una vez al cargar la página
 */

function getParam(name) {
  return new URLSearchParams(window.location.search).get(name);
}

function captureUtms() {
  var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'promotor'];
  var captured = {};
  keys.forEach(function(key) {
    var value;
    if (key === 'promotor') {
      value = getParam('gclid') || getParam('promotor');
    } else {
      value = getParam(key);
    }
    if (value) {
      localStorage.setItem('c_' + key, value);
      captured[key] = value;
    }
  });

  if (Object.keys(captured).length > 0) {
    console.log('[UTMs] Capturados:', captured);
  }
}

captureUtms();

function fillUtmInputs() {
  var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'promotor'];
  keys.forEach(function(key) {
    var value = localStorage.getItem('c_' + key);
    if (value) {
      var input = document.querySelector('input[name="properties[_' + key + ']"]');
      if (input) {
        input.value = value;
      }
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', fillUtmInputs);
} else {
  fillUtmInputs();
}